// extracted by mini-css-extract-plugin
export default {"logop":"Menu_logop__rSwwk","navbarpm":"Menu_navbarpm__CQRaX","menuItem":"Menu_menuItem__NR+g8","active":"Menu_active__GsTnO","logout":"Menu_logout__G8zyR"};